import { Trans } from "@lingui/react/macro";
import { Button } from "@silversea-ssc/ui-components-react";
import React from "react";
import { useClearRefinements } from "react-instantsearch";
import * as styles from "./ClearFiltersButton.module.scss";

const ClearFiltersButton = () => {
  const { refine, canRefine } = useClearRefinements();

  return (
    <React.Fragment>
      {canRefine && (
        <Button
          iconName="close"
          variant="inline-text"
          onClick={refine}
          className={styles.button}
          dataContentPiece="clear_filters_button"
        >
          <Trans>Clear all filters</Trans>
        </Button>
      )}
    </React.Fragment>
  );
};

export default ClearFiltersButton;
